// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BzTiHwx1ie4v5IANFTm8,.gvzkSTR4Lg0KlRd9n8uR{flex-direction:column;flex-grow:1;display:flex}.dNbbujeIWV8SUZiM2ryS{gap:8px;padding:16px 24px 24px;display:flex}.cWujxr397VYPooDySVr7{align-items:center;gap:8px;display:flex}.nTeJm3YUJr0VjUxlj56i{cursor:pointer;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BzTiHwx1ie4v5IANFTm8`,
	"content": `gvzkSTR4Lg0KlRd9n8uR`,
	"actions": `dNbbujeIWV8SUZiM2ryS`,
	"title": `cWujxr397VYPooDySVr7`,
	"link": `nTeJm3YUJr0VjUxlj56i`
};
export default ___CSS_LOADER_EXPORT___;
